<template>
  <v-container>
    <BossesProgressLinear></BossesProgressLinear>
    <v-spacer></v-spacer>
    <GenericChecklist @complete="complete" @uncomplete="uncomplete" :headers="[{text:'completed', value:'completed'}, {text:'boss', value:'name'}]" :items="filtered" :itemKey="'name'"></GenericChecklist>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex"

import GenericChecklist from '@/components/GenericChecklist'
import BossesProgressLinear from "@/components/BossesProgressLinear";


export default {
  name: "Bosses",
  components: { BossesProgressLinear, GenericChecklist },
  computed: {
    ...mapGetters("entities/bosses",["filtered"])
  },
  methods: {
    ...mapActions("entities/bosses", ["complete", "uncomplete"]),
  },
};
</script>
